import Swiper from 'swiper';
import {Autoplay, Navigation} from 'swiper/modules';
import {getOptionsFromJsonString} from "./utilities/options";

export function initScrollbars(query = document.querySelectorAll('.scrollbar'), customBreakpoints = null, linearMode = false, linearSpeed = 30, spaceBetween = 10) {
    for (const scrollbar of query) {
        const options = getOptionsFromJsonString(scrollbar.dataset.options, {
            autoplay_interval: 5000,
            eff_interval: 300
        });
        const childrenCount = scrollbar.querySelectorAll('.swiper-wrapper > *').length;
        let loop = false;

        const defaultBreakpoints = {
            xs: {
                items: 3,
                autoplay: childrenCount > 3,
            },
            sm: {
                items: 4,
                autoplay: childrenCount > 4,
            },
            md: {
                items: 5,
                autoplay: childrenCount > 5,
            }
        };

        const breakpoints = customBreakpoints || defaultBreakpoints;

        if (customBreakpoints) {
            for (const bp in breakpoints) {
                if (breakpoints[bp] && typeof breakpoints[bp].items !== 'undefined') {
                    breakpoints[bp].autoplay = linearMode ? true : childrenCount > breakpoints[bp].items;
                }
            }
        }

        const gridBreakpoints = {};

        gridBreakpoints.sm = 768;
        gridBreakpoints.md = 1024;

        if (typeof GLOBALS!== "undefined") {
            gridBreakpoints.sm = GLOBALS.gridBreakpoints.sm;
            gridBreakpoints.md = GLOBALS.gridBreakpoints.md;
        }

        if (linearMode) {
            loop = true;
        } else {
            if (window.outerWidth > gridBreakpoints.sm && childrenCount > breakpoints.sm.items) {
                loop = true;
            }

            if (window.outerWidth > gridBreakpoints.md && childrenCount > breakpoints.md.items) {
                loop = true;
            }
        }

        Swiper.use([Autoplay, Navigation]);

        const swiperConfig = {
            loop: loop,
            speed: linearMode ? 3000 : options.eff_interval,
            initialSlide: 0,
            spaceBetween: spaceBetween,
            slidesPerGroup: linearMode ? 1 : undefined,
            autoplay: linearMode ? {
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: false,
                reverseDirection: false,
                stopOnLastSlide: false,
            } : {
                delay: options.autoplay_interval,
            },
            navigation: {
                nextEl: scrollbar.querySelector('.swiper-button-next'),
                prevEl: scrollbar.querySelector('.swiper-button-prev'),
            },
            breakpoints: {
                0: {
                    slidesPerView: breakpoints.xs.items,
                    autoplay: linearMode ? {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        enabled: true
                    } : {
                        enabled: breakpoints.xs.autoplay
                    }
                },
                768: {
                    slidesPerView: breakpoints.sm.items,
                    autoplay: linearMode ? {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        enabled: true
                    } : {
                        enabled: breakpoints.sm.autoplay
                    }
                },
                1024: {
                    slidesPerView: breakpoints.md.items,
                    autoplay: linearMode ? {
                        delay: 0,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: false,
                        enabled: true
                    } : {
                        enabled: breakpoints.md.autoplay
                    }
                }
            }
        };

        if (linearMode) {
            scrollbar.classList.add('linear-scroll');
            const wrapper = scrollbar.querySelector('.swiper-wrapper');
            if (wrapper) {
                const slides = wrapper.querySelectorAll('.swiper-slide');
                slides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });

                wrapper.style.gap = `${spaceBetween}px`;
                wrapper.style.animation = `linearScroll ${linearSpeed}s linear infinite`;
                wrapper.style.willChange = 'transform';
            }
        } else {
            new Swiper(scrollbar, swiperConfig);
        }
    }
}
